import React from "react";
import { X } from "lucide-react";

const ConfirmationDialog = ({
  isOpen,
  onClose,
  title,
  content,
  showConfirm = false,
  showCancel = false,
  onConfirm,
  onCancel,
  confirmText = "Conferma",
  cancelText = "Annulla",
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
      onCancel?.();
    }
  };

  const handleCloseClick = () => {
    onClose();
    onCancel?.();
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 relative">
        {/* Close button */}
        <button
          onClick={handleCloseClick}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors"
        >
          <X size={20} />
        </button>

        {/* Title */}
        {title && <h2 className="text-xl font-semibold mb-4 pr-8">{title}</h2>}

        {/* Content */}
        <div className="text-gray-600 mb-6">{content}</div>

        {/* Buttons */}
        {(showConfirm || showCancel) && (
          <div className="flex justify-end gap-4">
            {showCancel && (
              <button
                onClick={() => {
                  onClose();
                  onCancel?.();
                }}
                className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
              >
                {cancelText}
              </button>
            )}
            {showConfirm && (
              <button
                onClick={() => {
                  onClose();
                  onConfirm?.();
                }}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
              >
                {confirmText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmationDialog;
